export const accomplishments = [
  {
    key: 1,
    className: "wol",
    title: "Week of Learning",
    date: "(From 24th april to 4th May)",
    details:
      'An exquisite 10 day online event by ACM-W included an access of free course of HTML, CSS and JavaScript for 7 days on the platform "Progate". On the 8th day, the project day, member of the organizing team explained and gave a demonstration of the web project. The 10th day concluded the event with a webathon in which all the participants submited their individual projects and were marked by the judges on their creativity, presentation and development. The first 3 winners were awarded with certificates, Amazon vouchers and ACM goodies and swags.'
  },
  {
    key: 2,
    className: "cib",
    title: "Code - Intine Bytes",
    date: "(20th April to 26th April, New Challenge Daily!)",
    details:
      "Lockdown increased the usage of social media tremendously. It also became the new social hub of events and opportunities. Hence, we conducted a weeklong of predict the output questions developed by the members of ACM-W. The first 2 winners of each day were awarded with swags."
  },
  {
    key: 3,
    className: "hoc",
    title: "Hour of Code",
    date: "(January’20)",
    details:
      "The foundation of good team is based the zeal for knowledge and creation within themselves and extending this with those who are less privileged. Under the ACM - Parivartan chapter, we taught basics of programming, logic and STEM benefits to around 200 kids in New Multan Government School. The team had a great time interacting with the kids and experience was truly unparalleled."
  },
  {
    key: 4,
    className: "dsp",
    title: "Distinguished Speaker",
    date: "(7th April, 2020 at 12:30pm IST through online conference)",
    details:
      'The technology brings us all really close. The talk by Dr. Qi Han who is an ACM and IEEE senior member (which was initially cancelled because of the lockdown) was only possible through a video call. Her talk on "Detection and Tracking of Dynamic Amorphous Events in Wireless Sensors Networks" was very insightful and informative. It gave a different perspective to look at wireless networking. In the end, there was an interactive "Question and Answer" round followed by "Know Me More" talks.'
  }
];
